import Button from "@/components/common/Buttons/Button";
import {useCallback, useImperativeHandle, useState, forwardRef} from "react";
import NewsletterModal from "@/components/ModalVariants/NewsletterModal";
import useGlobals from "@/hooks/useGlobals";

const NewsletterModalAction = forwardRef(({ showButton = true }, ref) => {
	const footer = useGlobals(state => state.footer)
	const buttonText = footer?.newsletter?.buttonText || ''

	const [modalOpen, setModalOpen] = useState(false)

	const handleModalOpen = useCallback(() => {
		setModalOpen(true)
	},[])

	const handleModalClose = useCallback(() => {
		setModalOpen(false)
	},[])

	useImperativeHandle(ref, () => ({
		handleModalOpen
	}));

	return <>
		<NewsletterModal isOpen={modalOpen} handleClose={handleModalClose} />
		{showButton && (
			<Button onClick={handleModalOpen}>{buttonText}</Button>
		)}
	</>
});

NewsletterModalAction.displayName = 'NewsletterModalAction';

export default NewsletterModalAction;
